<!-- <p>asset-charts works!</p> -->
<mat-toolbar class="asset-chart-toolbar alignRow">
	<div class="hideoverflow" *ngIf="selectedAsset">
		<span>
			{{selectedAsset.Name}} -
			{{selectedAsset.Description}} ({{getShortDate(visibleStartDate)}} -
			{{getShortDate(visibleEndDate)}})</span>
	</div>
	<span class="toolbar-spacer"></span>
	<div class="noshrink alignRow">
		<mat-icon matTooltip="Navigate Backwards" (click)="navigateByDuration(false)">chevron_left</mat-icon>
		<app-duration-selector [(duration)]="strDuration" (durationChange)="selectTime($event)"></app-duration-selector>
		<mat-icon matTooltip="Navigate Forwards" (click)="navigateByDuration(true)">chevron_right</mat-icon>
	</div>
	<span mat-icon-button [matMenuTriggerFor]="timeMenu" style="margin-left: 10px;" class="alignRow"
		#timeTrigger="matMenuTrigger" matTooltip="Date Range">
		<mat-icon>access_time</mat-icon>
	</span>
	<span mat-icon-button [matMenuTriggerFor]="chartMenu" style="margin-left: 10px;" class="alignRow"
		matTooltip="Chart Options">
		<mat-icon>more_horiz</mat-icon>
	</span>
</mat-toolbar>

<mat-menu #chartMenu>
	<div class="chart-menu" (click)="$event.stopPropagation()">
		<div class="mat-menu-buttons">
			<span class="alignRow" mat-icon-button [matTooltip]="!tabulate ? 'Table View' : 'Chart View'"
				(click)="toggleTabulate($event)">
				<mat-icon *ngIf="!tabulate">table_view</mat-icon>
				<mat-icon *ngIf="tabulate">analytics</mat-icon>
			</span>
			<span class="alignRow" mat-icon-button [matMenuTriggerFor]="exportMenu" *ngIf="!tabulate"
				matTooltip="Export Chart Data">
				<mat-icon>file_download</mat-icon>
			</span>
			<span *ngIf="includesCumulativeDatapoints && !tabulate" class="alignRow" mat-icon-button
				[matTooltip]="!showDeltaAsBar ? 'Bar Graph' : 'Line Graph'" (click)="toggleShowBars($event)">
				<mat-icon>{{showDeltaAsBar ? "show_chart" : "bar_chart"}}</mat-icon>
			</span>
			<span *ngIf="checkFeature(AccountFeatures.Average_Trend_Line) && !tabulate" class="alignRow" mat-icon-button
				[matTooltip]="!showAverageTrend ? 'Show Average' : 'Show Raw'" (click)="toggleShowAverage()">
				<mat-icon>{{!showAverageTrend ? "area_chart" : "raw_on"}}</mat-icon>
			</span>
		</div>
		<div class="agg-selector" *ngIf="checkFeature(AccountFeatures.Average_Trend_Line) && !tabulate">
			<span>Average Trend Granularity</span>
			<ejs-dropdownlist id="dropdown" #dropdown [dataSource]='averagingWindowOptions'
				[(value)]="selectedGranularity" [fields]="averagingWindowOptionFields"
				(change)="granularityChange($event)">
				<ng-template #itemTemplate let-data>
					<div>
						<span>{{ data.name }}</span>
					</div>
				</ng-template>
			</ejs-dropdownlist>
		</div>
	</div>
</mat-menu>

<div class="chartMainArea">
	<div class="chartSideTabs">
		<span class="alignRow" mat-icon-button (click)="openSidenav(0)" matTooltip="View Datapoints"
			matTooltipPosition="left">
			<mat-icon>sensors</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button (click)="openSidenav(1)" matTooltip="View Rules"
			matTooltipPosition="left">
			<mat-icon>rule</mat-icon>
		</span>
		<span *ngIf="checkFeature(AccountFeatures.Virtual_Sensors) && assetVirtualSensors.length > 0" class="alignRow"
			mat-icon-button (click)="openSidenav(2)" matTooltip="View Virtual DataPoints" matTooltipPosition="left">
			<mat-icon>mediation</mat-icon>
		</span>
		<div class="toolbar-spacer"></div>

		<ng-container *ngIf="checkFeature(AccountFeatures.SAP) else noSAP">
			<span class="alignRow" mat-icon-button matTooltip="Actions" matTooltipPosition="left"
				[matMenuTriggerFor]="cmmsMenu">
				<mat-icon>content_paste</mat-icon>
			</span>
		</ng-container>
		<ng-template #noSAP>
			<span class="alignRow" mat-icon-button *ngIf="checkFeature(AccountFeatures.Actions)"
				(click)="createAction()" matTooltip="Create an Action" matTooltipPosition="left">
				<mat-icon>content_paste</mat-icon>
			</span>
		</ng-template>
		<span class="alignRow" mat-icon-button (click)="popUpActionList()" matTooltip="View Actions"
			style="background-color: var(--action-bg-color) !important;" matTooltipPosition="left"
			*ngIf="(selectedAsset && selectedAsset.Actioned) && checkFeature(AccountFeatures.Actions)">
			<mat-icon>content_paste_go</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button (click)="openAssetModels()" matTooltip="Models"
			matTooltipPosition="left">
			<mat-icon>auto_awesome</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button (click)="compareAsset()" matTooltip="Compare Asset"
			matTooltipPosition="left">
			<mat-icon>stacked_line_chart</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button (click)="popUpWatchList()" matTooltip="Watch List"
			style="background-color: var(--watch-bg-color) !important;" matTooltipPosition="left"
			*ngIf="(selectedAsset && selectedAsset.Watch)">
			<mat-icon>visibility_on</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button *ngIf="checkFeature(AccountFeatures.Asset_Information)"
			(click)="popUpInformation()" matTooltip="Asset Information" matTooltipPosition="left">
			<mat-icon>information</mat-icon>
		</span>
		<span class="alignRow" mat-icon-button (click)="popUpHistory()" matTooltip="Event & Action History"
			matTooltipPosition="left">
			<mat-icon>history</mat-icon>
		</span>


	</div>
	<mat-sidenav-container class="chart-sidenav-container alignRow">
		<mat-sidenav class="chart-sidenav" mode="side" #datapointSidenav="matSidenav" (opened)="RefreshMyChart()"
			(closed)="RefreshMyChart()">
			<mat-toolbar class="sidenavtoolbar alignRow">
				<span *ngIf="selectedItem == 0" class="alignRow"><mat-icon>sensors</mat-icon>&nbsp;Datapoints</span>
				<span *ngIf="selectedItem == 1" class="alignRow"><mat-icon>rule</mat-icon>&nbsp;Rules</span>
				<span *ngIf="selectedItem == 2" class="alignRow"><mat-icon>mediation</mat-icon>&nbsp;Virtual
					DataPoints</span>
				<span class="toolbar-spacer"></span>

				<ng-container *ngIf="selectedAccount.Admin">
					<button class="sidebarAddButton alignRow app-icon app-icon--settings" mat-button
						(click)="ManageDatapoints()" *ngIf="selectedItem == 0">
						<span>Manage</span><mat-icon>edit</mat-icon>
					</button>
					<button class="sidebarAddButton alignRow app-icon app-icon--settings" mat-button
						(click)="ManageRules()" *ngIf="selectedItem == 1">
						<span>Manage</span><mat-icon />
					</button>
					<button class="sidebarAddButton alignRow app-icon app-icon--settings" mat-button
						*ngIf="selectedItem == 2">
						<span>Manage</span><mat-icon />
					</button>
				</ng-container>

				<span mat-icon-button (click)="closeSidenav(datapointSidenav)" class="alignRow">
					<mat-icon matTooltip="Close" matTooltipPosition="right">close</mat-icon>
				</span>
			</mat-toolbar>
			<ng-container *ngIf="selectedItem == 0" [ngTemplateOutlet]="datapointsListview"></ng-container>
			<ng-container *ngIf="selectedItem == 1" [ngTemplateOutlet]="rulesbox"></ng-container>
			<ng-container *ngIf="selectedItem == 2" [ngTemplateOutlet]="virtualDatapointsBox"></ng-container>
		</mat-sidenav>
		<mat-sidenav-content>
			<ng-container *ngTemplateOutlet="AssetChart"></ng-container>
			<ng-container *ngIf="tabulate then assetGrid"></ng-container>
			<div class="local-spinner" *ngIf="spinner">
				<img src="https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/circle-lines.gif"
					[attr.x-contenttype]="'image/gif'" alt="Loading..." style="max-height: 200px;" />
			</div>
		</mat-sidenav-content>
	</mat-sidenav-container>
</div>

<!-- Template for the Chart -->
<ng-template #AssetChart>
	<ngcontainer class="ChartDiv" #chartContainer [ngStyle]="{'display': noDatapoints ? 'none' : ''}">
		@if(noData) {
		<div class="no-data-message alignRow">
			<span>No Data for Selected Period</span>
		</div>
		}
		<ejs-chart #myChart id="chart-sensor" [primaryXAxis]='sensorXAxis' (load)="load($event)"
			[zoomSettings]="zoomSettings" [legendSettings]='legend' [tooltip]='tooltipSettings' [crosshair]='crosshair'
			background="transparent" [border]="borderSettings" [titleStyle]="titleStyle" [palettes]='palette'
			(onZooming)="chartMouseDown($event)" (zoomComplete)="zoomComplete($event)" (zoomComplete)="onZoom($event)"
			(scrollChanged)="onScroll($event)" (chartMouseDown)="checkClick($event)"
			(dragComplete)="zoomComplete($event)" [selectionMode]='selectionMode' (dragComplete)='dragComplete($event)'
			(resized)="chartresized($event)" (chartMouseMove)="chartHover($event)"
			(tooltipRender)="onTooltipRender($event)" (loaded)="onLoading($event)" [height]="'100%'"
			(seriesRender)="onSeriesRender($event)">
		</ejs-chart>
	</ngcontainer>
</ng-template>

<!-- Template for the Table Data -->
<ng-template #assetGrid>
	<div id="ChartTableDiv" #chartContainer class="chart-datagrid-overlay">
		<ejs-grid #Grid *ngIf="gridData.length > 0" [dataSource]='gridData' [allowSorting]='true'
			[allowFiltering]='true' [filterSettings]='filterSettings' [editSettings]='editSettings'
			[loadingIndicator]='loadingIndicator' (dataBound)="gridLoad()" [columns]="gridColumns">
		</ejs-grid>
	</div>
</ng-template>

<!-- Template to display the Datapoints -->
<ng-template #datapointsListview>
	<div class="scrollable-list-container">
		<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='dataPoints' cssClass='e-list-template'>
			<ng-template #template let-dataSource>
				<div class="clickable-datapoint">
					<div class="datapoint-list" (click)="HighlightDP(dataSource)"
						[ngStyle]="{'border': '2px solid ' + (HilightedSeries?.DataPointID === dataSource.DataPointID ? dataSource.SeriesColor: 'transparent')}">
						<div class="chart-listview-datapoint">
							<img class="image" (click)="viewImage(imagePathSensors(dataSource))"
								src="{{imagePathSensors(dataSource)}}"
								onerror="this.src='https://stmgwebappstorage.blob.core.windows.net/prismpdm/assets/noimage.png'" />
							<div class="detail">
								<span id="name" class="name">{{ dataSource.SensorName }}</span>
								<span id="description" class="description">{{ dataSource.PVName }} {{ dataSource.SI ?
									'(' + dataSource.SI + ')' : '' }}</span>
							</div>
							<div class="me-auto"></div>
							<div>
								<mat-checkbox *ngIf="myChart && myChart.series && getSeries(dataSource)" color="primary"
									[checked]="getSeries(dataSource)?.visible"
									(change)="toggleDatapoint($event, dataSource)"
									(click)="$event.stopPropagation()"></mat-checkbox>
							</div>
							<!-- <div *ngIf="checkFeature(AccountFeatures.Average_Trend_Line)">
								<mat-checkbox *ngIf="myChart && myChart.series && getSeries(dataSource)" color="primary"
									[checked]="getAvgSeriesVisible(dataSource)"
									(change)="toggleAverage($event, dataSource)"
									(click)="$event.stopPropagation()">Avg</mat-checkbox>
							</div> -->
						</div>

						<div class="datapoint-min-max">
							<span>Min:</span>
							<span class="value" *ngIf="uniqueDPs && uniqueDPs.length > 0">
								{{getMinMaxForDP(dataSource.DataPointID)[0] }}{{ dataSource.SI}}
							</span>
							<span>Max:</span>
							<span class="value" *ngIf="uniqueDPs && uniqueDPs.length > 0">
								{{getMinMaxForDP(dataSource.DataPointID)[1] }}{{ dataSource.SI}}
							</span>
							<span>{{ dataSource.IsCumulative ? "Diff:" : "Period Avg:" }}</span>
							<span class="value" *ngIf="uniqueDPs && uniqueDPs.length > 0 && averagedData">
								{{!dataSource.IsCumulative ? findAverage(dataSource).average :
								findDifference(dataSource)}}{{
								dataSource.SI }}</span>
							<ng-container
								*ngIf="!dataSource.IsCumulative && findAverage(dataSource).average != findAverage(dataSource).runningAvg">
								<span>Running Avg:</span>
								<span class="value" *ngIf="uniqueDPs && uniqueDPs.length > 0">
									{{findAverage(dataSource).runningAvg }}{{ dataSource.SI}}
								</span>
							</ng-container>
						</div>
					</div>
					<div class="datapoint-colour" [ngStyle]="{'background-color': dataSource.SeriesColor}"></div>
				</div>
			</ng-template>
		</ejs-listview>
	</div>
</ng-template>

<!-- Template for the list of Rules -->
<ng-template #rulesbox>
	<ng-container *ngIf="assetRules.length > 0 ; else NoRules">
		<div class="scrollable-list-container" *ngIf="(assetRules && assetRules[0].RuleID != 0)">
			<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='assetRules'
				cssClass='e-list-template'>
				<ng-template #template let-dataSource>
					<div class="chart-listview-rule alignRow">
						<div class="text">
							<span>{{ dataSource.RuleDescription }}
								<small *ngIf="!dataSource.RuleEnabled">Disabled</small>
							</span>
						</div>
						<mat-checkbox class="checkbox" color="primary"
							(change)="selectRule(dataSource, $event)"></mat-checkbox>
					</div>
					<span class="rule-text">{{ makeRuleReadable(dataSource) }}</span>
				</ng-template>
			</ejs-listview>
		</div>
	</ng-container>
	<ng-template #NoRules>
		<div>This asset has no rules.</div>
	</ng-template>
</ng-template>

<!-- Template to display the virtual Datapoints -->
<ng-template #virtualDatapointsBox>
	<div class="scrollable-list-container">
		<ejs-listview id='listview-scrolling' #listviewInstance [dataSource]='assetVirtualSensors'
			cssClass='e-list-template'>
			<ng-template #template let-dataSource>
				<div class="virtual-datapoint ejs-listbox-item">
					<div class="virtual-datapoint-title">{{dataSource.VirtualSensorName}}</div>
					<div class="virtual-datapoint-details">
						<span>Input DataPoints:</span>
						<span></span>
						<ng-container *ngFor="let dp of dataSource._dataPoints">
							<span>{{dp.value}}:</span>
							<span>{{dp.datapoint.DPTitle}}</span>
						</ng-container>
						<span>Conversion:</span>
						<span>{{dataSource.Conversion}}</span>
					</div>
				</div>
			</ng-template>
		</ejs-listview>
	</div>
</ng-template>

<!-- Menu for the time selection -->
<mat-menu #timeMenu="matMenu">
	<div style="margin: 1em;">
		<app-date-range-picker (datePickerChange)="DatePickerChange($event)"
			[matMenuTrigger]="timeTrigger"></app-date-range-picker>
	</div>
</mat-menu>

<!-- Menu for the Chart export options -->
<mat-menu #exportMenu="matMenu" style="padding:1em; border: 0px;">
	<form style="margin:1em">
		<mat-form-field>
			<mat-label>Export Type:</mat-label>
			<mat-select name="selectIndex" id="exporttype" [(ngModel)]="selectedExportType"
				(click)="stopPropagation($event)">
				<mat-option selected value="JPEG">JPEG</mat-option>
				<mat-option value="PNG">PNG</mat-option>
				<mat-option value="SVG">SVG</mat-option>
				<mat-option value="PDF">PDF</mat-option>
				<mat-option value="XLSX">XLSX</mat-option>
				<mat-option value="CSV">CSV</mat-option>
			</mat-select>
		</mat-form-field>
		<mat-form-field>
			<input matInput autocomplete="off" type="text" placeholder="File Name" [value]="selectedExportFilename"
				id="fileName">
		</mat-form-field>
		<div style="display: flex; justify-content: center; margin-top: 20px;">
			<button mat-raised-button color="primary" (click)="onClick($event)" style="text-transform:none !important"
				id="togglebtn">EXPORT</button>
		</div>
	</form>
</mat-menu>


<mat-menu #cmmsMenu>
	<button mat-menu-item (click)="createAction()" *ngIf="checkFeature(AccountFeatures.Actions)">
		<mat-icon>content_paste</mat-icon><span>Create an Action</span>
	</button>
	<button mat-menu-item (click)="addCmmsCase()" *ngIf="checkFeature(AccountFeatures.SAP)">
		<mat-icon>work</mat-icon><span>Create CMMS Case</span>
	</button>
</mat-menu>